/**
 * MAK Device Actions
 * 處理 MAK 裝置相關的 NGXS Actions
 */

// 查詢 MAK 綁定狀態
export class CheckMakStatus {
  static readonly type = '[MakDevice] CheckMakStatus';
  constructor(public mac_address: string) {}
}

// 綁定脈安扣
export class BindMak {
  static readonly type = '[MakDevice] BindMak';
  constructor(
    public team_id: string,
    public user_id: string,
    public mac_address: string
  ) {}
}

// 查詢使用者擁有的 MAK 裝置清單
export class GetMakDevices {
  static readonly type = '[MakDevice] GetMakDevices';
}

// 查詢某一個 MAK 的音檔清單
export class GetMakMp3s {
  static readonly type = '[MakDevice] GetMakMp3s';
  constructor(public mak_device_id: number) {}
}

// 初始化本地快取的 MAK 裝置清單
export class InitLocalCacheMakDevices {
  static readonly type = '[MakDevice] InitLocalCacheMakDevices';
}

// 載入本地快取的 MAK 裝置清單
export class LoadCacheMakDevices {
  static readonly type = '[MakDevice] LoadCacheMakDevices';
}

// 重新整理 MAK 裝置清單
export class RefreshMakDevices {
  static readonly type = '[MakDevice] RefreshMakDevices';
}

// 處理 MAK Device (用於 deep link 和 QR code 掃描)
export class ProcessMakDevice {
  static readonly type = '[MakDevice] Process Mak Device';
  constructor(public mac_address: string) {}
}
